export default {
  "enterprise": {
    "title": "法人"
  },
  "login": {
    "title": "ログイン",
    "user_id": "ユーザーID",
    "password": "パスワード",
    "enterprise": {
      "title": "法人ログイン",
      "id": "法人ID",
      "remember_me": "ログイン情報を記録する",
      "forget_password": "パスワードをお忘れの方は、担当者へお問い合わせください。"
    }
  }
}
